import FormLabel from '@rio-cloud/rio-uikit/FormLabel';
import Multiselect, { type MultiselectOption, type MultiselectProps } from '@rio-cloud/rio-uikit/Multiselect';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { type Control, useController } from 'react-hook-form';

import { ValidationViolation } from './ValidationViolation.tsx';

type Props = MultiselectProps<MultiselectOption> & {
    // biome-ignore lint/suspicious/noExplicitAny: <react-hook-form> types
    control: Control<any>;
    label: string;
    className?: string;
    name: string;
    formGroupClassName?: string;
    options: MultiselectOption[];
    onValueChange?: (selectedItemIds: string[]) => void;
};

export const ControlledMultiselect = forwardRef<HTMLInputElement, Props>(
    ({ label, name, control, formGroupClassName, options, onValueChange, ...props }, _ref) => {
        const { field, fieldState } = useController({ control, name: name });
        return (
            <div
                className={classNames('form-group', formGroupClassName, {
                    'form-group-lg': false,
                    'has-error': fieldState.invalid,
                    'has-feedback': fieldState.invalid,
                })}
            >
                <FormLabel htmlFor={field.name}>{label}</FormLabel>
                <Multiselect
                    {...props}
                    name={name}
                    id={field.name}
                    options={options}
                    value={field.value ?? []}
                    onChange={selectedItemIds => {
                        if (onValueChange) {
                            onValueChange(selectedItemIds);
                            return;
                        }

                        field.onChange(selectedItemIds);
                    }}
                />
                <ValidationViolation violations={fieldState.error?.message} />
            </div>
        );
    }
);
